import { useTranslation } from "react-i18next"
import {
  Radar,
  RadarChart as RechartsRadar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts"

export function RadarChartExample() {
  const { t } = useTranslation()

  const data = [
    {
      attribute: t("charts.radar.aroma"),
      geisha1: 8.5,
      geisha2: 7.5,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.flavor"),
      geisha1: 8.0,
      geisha2: 8.5,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.acidity"),
      geisha1: 8.5,
      geisha2: 7.0,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.body"),
      geisha1: 7.0,
      geisha2: 8.0,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.sweetness"),
      geisha1: 8.0,
      geisha2: 7.5,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.balance"),
      geisha1: 8.0,
      geisha2: 8.5,
      fullMark: 10,
    },
    {
      attribute: t("charts.radar.aftertaste"),
      geisha1: 7.5,
      geisha2: 8.0,
      fullMark: 10,
    },
  ]

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsRadar data={data}>
          <PolarGrid stroke="hsl(var(--border))" />
          <PolarAngleAxis
            dataKey="attribute"
            tick={{ fill: "hsl(var(--foreground))", fontSize: 12 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 10]}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }}
            tickCount={6}
          />
          <Radar
            name="Geisha 1"
            dataKey="geisha1"
            stroke="hsl(142, 76%, 36%)"
            fill="hsl(142, 76%, 36%)"
            fillOpacity={0.2}
            strokeWidth={2}
          />
          <Radar
            name="Geisha 2"
            dataKey="geisha2"
            stroke="hsl(30, 100%, 50%)"
            fill="hsl(30, 100%, 50%)"
            fillOpacity={0.2}
            strokeWidth={2}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: "var(--radius)",
            }}
            formatter={(value: number | undefined) =>
              value?.toFixed(1) ?? "0.0"
            }
          />
        </RechartsRadar>
      </ResponsiveContainer>
    </div>
  )
}
